import { ViewModeCapabilityCoordinator } from '@mobile-mapping/web3d';
import { CapabilityRegistry } from '@trimble/web3d';

export function isAnyPaneInPanoramaMode(registry: CapabilityRegistry): boolean {
  for (const container of registry.paneContainers()) {
    const coordinator = container.get(ViewModeCapabilityCoordinator)();
    if (coordinator?.viewMode().type === 'Panorama') {
      return true;
    }
  }
  return false;
}
